/**
 * Display names for research firms.
 *
 * The feed publishes full legal names — "Bank of America Securities" — which
 * are too long for the narrow firm column on Market Overview and the ratings
 * widget, where they truncate mid-word to something unreadable. Shortening at
 * the point of display, not on the way in: the raw value is what the provider
 * said, and it stays that way in the data.
 *
 * Only names that actually overflow belong here. A map of every firm would be
 * a second source of truth for something the feed already gets right.
 */
const FIRM_DISPLAY_NAMES: Record<string, string> = {
  'Bank of America Securities': 'BofA Securities',
};

/** The firm name as it should be shown. Unknown firms pass through unchanged. */
export function firmDisplayName(firm: string | null | undefined): string {
  if (!firm) return '—';
  return FIRM_DISPLAY_NAMES[firm] ?? firm;
}
